import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=44cb6ef8&scoped=true&"
import script from "./EmailTemplates.vue?vue&type=script&lang=js&"
export * from "./EmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=44cb6ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb6ef8",
  null
  
)

export default component.exports